import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const StyledImage = styled.img`
    width: 100%;
    border: thin solid ${theme.color.midnight50};
`;
